import React, { useState, useEffect } from 'react';
import { Flex, Box } from 'rebass';
import { Label, Input, Textarea, Switch } from '@rebass/forms';
import helpers from 'utils/helpers';

function ScreenerTranslationComponent(props) {

    return (
        <Box style={{ width: '400px' }}>
            <Label className="" htmlFor="submit_button_text">
                Submit Button Text
            </Label>
            <Input
                name="submit_button_text"
                value={props.screener_translation.submit_button_text}
                placeholder="Submit"
                onChange={e => props.handleTranslationChange(e)}
            />
            <Label className="" mt={3} htmlFor="cancel_button_text">
                Cancel Button Text
            </Label>
            <Input
                name="cancel_button_text"
                value={props.screener_translation.cancel_button_text}
                placeholder="Cancel"
                onChange={e => props.handleTranslationChange(e)}
            />
            <Label className="" mt={3} htmlFor="is_required_text">
                Validation: Is required Text
            </Label>
            <Input
                name="is_required_text"
                value={props.screener_translation.is_required_text}
                placeholder="is required"
                onChange={e => props.handleTranslationChange(e)}
            />
            <Label className="" mt={3} htmlFor="dismiss_text">
                Validation: Dismiss Text
            </Label>
            <Input
                name="dismiss_text"
                value={props.screener_translation.dismiss_text}
                placeholder="Dismiss"
                onChange={e => props.handleTranslationChange(e)}
            />
            <Label className="" mt={3} htmlFor="confirmation_page_text">
                Confirmation Page Text
            </Label>
            <Textarea
                name="confirmation_page_text"
                value={props.screener_translation.confirmation_page_text}
                placeholder="Thank you!"
                onChange={e => props.handleTranslationChange(e)}
            />


            <Label className="" mt={3} htmlFor="confirmation_page_text">
                Redirect after Confirmation
            </Label>
            <Flex>
                <Box>
                    <Switch
                        id="opt-out-opt-in"
                        className='switch-small'
                        onClick={e => {
                            props.handleTranslationChange({
                                target: {
                                    name: 'confirmation_redirect',
                                    value: props.screener_translation.confirmation_redirect ? false : true
                                }
                            })
                        }}
                        checked={props.screener_translation.confirmation_redirect}
                        mr={3}
                        style={{marginTop: '8px'}}
                    />
                </Box>
                <Box>
                    { props.screener_translation.confirmation_redirect && props.screener_translation.confirmation_redirect == true &&
                        <Input
                            type="text"
                            name="confirmation_redirect_url"
                            value={props.screener_translation.confirmation_redirect_url}
                            placeholder="https://link-to-page.com"
                            onChange={e => props.handleTranslationChange(e)}
                            className={helpers.isValidUrl(props.screener_translation.confirmation_redirect_url) ? '' : 'error'}
                        />
                    }
                </Box>
            </Flex>
            <Label className="" mt={3} htmlFor="disqualification_page_text">
                Disqualification Page Text
            </Label>
            <Textarea
                name="disqualification_page_text"
                value={props.screener_translation.disqualification_page_text}
                placeholder="Unfortunately you have been disqualified."
                onChange={e => props.handleTranslationChange(e)}
            />
            <Label className="" mt={3} htmlFor="confirmation_page_text">
                Redirect after Disqualification
            </Label>
            <Flex>
                <Box>
                    <Switch
                        id="opt-out-opt-in"
                        className='switch-small'
                        onClick={e => {
                            props.handleTranslationChange({
                                target: {
                                    name: 'disqualification_redirect',
                                    value: props.screener_translation.disqualification_redirect ? false : true
                                }
                            })
                        }}
                        checked={props.screener_translation.disqualification_redirect}
                        mr={3}
                        style={{marginTop: '8px'}}
                    />
                </Box>
                <Box>
                    { props.screener_translation.disqualification_redirect && props.screener_translation.disqualification_redirect == true &&
                        <Input
                            type="text"
                            name="disqualification_redirect_url"
                            value={props.screener_translation.disqualification_redirect_url}
                            placeholder="https://link-to-page.com"
                            onChange={e => props.handleTranslationChange(e)}
                            className={helpers.isValidUrl(props.screener_translation.disqualification_redirect_url) ? '' : 'error'}
                        />
                    }
                </Box>
            </Flex>
        </Box>
    );
}

export default ScreenerTranslationComponent;